const LOYALTY_SERVICE_URL: string =
  import.meta.env.VITE_LOYALTY_API_URL ||
  "https://api.loyaltybeta.cxforge.com/api/loyaltyservice";
const LOYALTY_CAMPAIGN_SERVICE_URL: string =
  import.meta.env.VITE_LOYALTY_CAMPAIGN_SERVICE_URL ||
  "https://api.loyaltybeta.cxforge.com/api/campaignservice";

const KEYCLOAK_URL: string = import.meta.env.VITE_KEYCLOAK_URL || "";
const KEYCLOAK_REALM: string = import.meta.env.VITE_KEYCLOAK_REALM || "";
const KEYCLOAK_CLIENT_ID: string =
  import.meta.env.VITE_KEYCLOAK_CLIENT_ID || "";
const REGION_ID: string = import.meta.env.VITE_REGION_ID || "";
const DEFAULT_MERHCHANT_LOCATION_ID: string =
  import.meta.env.VITE_DEFAULT_MERHCHANT_LOCATION_ID || "";
const BUSINESS_MAIN_PAGE = import.meta.env.VITE_BUSINESS_MAIN_PAGE || "";
const BUSINESS_SOCIALS_FACEBOOK =
  import.meta.env.VITE_BUSINESS_SOCIALS_FACEBOOK || "";
const BUSINESS_SOCIALS_INSTAGRAM =
  import.meta.env.VITE_BUSINESS_SOCIALS_INSTAGRAM || "";
const LOYALTY_PROGRAMME_NAME =
  import.meta.env.VITE_LOYALTY_PROGRAMME_NAME || "Loyalty Programme";
const LOYALTY_PROGRAMME_TAG_LINE =
  import.meta.env.VITE_LOYALTY_PROGRAMME_TAG_LINE || "";
const LOYALTY_PROGRAMME_TAG_LINE_DESCRIPTION =
  import.meta.env.VITE_LOYALTY_PROGRAMME_TAG_LINE_DESCRIPTION || "";

export {
  LOYALTY_SERVICE_URL,
  KEYCLOAK_URL,
  KEYCLOAK_REALM,
  KEYCLOAK_CLIENT_ID,
  REGION_ID,
  DEFAULT_MERHCHANT_LOCATION_ID,
  LOYALTY_CAMPAIGN_SERVICE_URL,
  LOYALTY_PROGRAMME_NAME,
  LOYALTY_PROGRAMME_TAG_LINE,
  LOYALTY_PROGRAMME_TAG_LINE_DESCRIPTION,
  BUSINESS_MAIN_PAGE,
  BUSINESS_SOCIALS_FACEBOOK,
  BUSINESS_SOCIALS_INSTAGRAM,
};
